<template>
  <div class="auth-layout">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'AuthLayout'
}
</script>

<style scoped>
.auth-layout {
  min-height: 100vh;
  min-height: 100dvh;
  background-color: var(--el-bg-color-page);
  padding: 24px 16px;
  box-sizing: border-box;
  display: grid;
  place-items: center;
  overflow-y: auto;
}
</style> 